import React from "react";

export default function TrombinoSkeleton() {
  return (
    <div className="grid gap-5 xl:grid-cols-2">
      {Array.from({ length: 6 }).map((_, index) => (
        <div
          key={index}
          className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-950"
        >
          <div className="h-2 bg-slate-200 dark:bg-slate-800" />

          <div className="grid gap-5 p-5 sm:grid-cols-[150px_1fr] sm:p-6">
            <div className="mx-auto h-52 w-40 animate-pulse rounded-[1.7rem] bg-slate-200 dark:bg-slate-800 sm:mx-0" />

            <div className="space-y-4">
              <div className="flex gap-2">
                <div className="h-6 w-32 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
                <div className="h-6 w-28 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
              </div>

              <div className="h-7 w-3/4 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
              <div className="h-5 w-1/2 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />

              <div className="h-24 animate-pulse rounded-3xl bg-slate-100 dark:bg-slate-900" />

              <div className="space-y-2">
                <div className="h-4 w-full animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
                <div className="h-4 w-10/12 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}